import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListitemBuilder } from '././../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroDataComponent } from '././../../../../shared/filtro-data/filtro-data.component';

@Component({
  selector: 'app-commercial-atacado-filtro',
  templateUrl: './commercial-atacado-filtro.component.html',
  styleUrls: ['./commercial-atacado-filtro.component.css']
})
export class CommercialAtacadoFiltroComponent implements OnInit {
  @Input() filtros: any;
  Sysdate: FiltroDataComponent = new FiltroDataComponent;
  InicialData; // Set the first Day of month
  dataInicialFormata;
  FinalData; // set the last day of query
  dataFinalFormata;
  ano: any;
  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  anoPosterior = new Date();
  anoDropDown = {};
 
  parametrosFiltro: any;
  
  @Output() filtroAlterado: EventEmitter<any> = new EventEmitter<any>();

  constructor(private route: ActivatedRoute) { 

      this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['ano']);
      });
  }

  ngOnInit(): void {
    this.carregarAno();
    this.geraAnoDropDown();
    this.setaValorData(null);
  }

  setaValorData(ano: any) {
    
    if (ano === undefined || ano === null) {
      var data = new Date();
      var mes = String(data. getMonth() + 1). padStart(2, '0')
      if (parseInt(mes) >= 7){
        this.ano = this.anoPosterior.getFullYear() +1;
      }else{
        this.ano = this.anoAtual.getFullYear();
      }      
    }

    this.filtros = { ano: this.ano };
  }

  set Ano(ano: any) { this.filtros.ano = this.tratarSetDropDown(ano); }
  get Ano(): any { return this.tratarGetDropDown(this.filtros.ano); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  private carregarAno() {
    this.ano =
      new ListitemBuilder()
        .add(1, this.anoRetrasado.getFullYear() - 2)
        .add(2, this.anoAnterior.getFullYear() - 1)
        .add(3, this.anoAtual.getFullYear())
        .add(4, this.anoPosterior.getFullYear() + 1)
        .build();
  }

  private geraAnoDropDown() {
    this.anoDropDown = [
      {"value": this.anoRetrasado.getFullYear() - 2},
      {"value": this.anoAnterior.getFullYear() - 1},
      {"value": this.anoAtual.getFullYear()},
      {"value": this.anoPosterior.getFullYear() + 1}
    ]
  }

  onKey(event){
    this.filtroAlterado.emit(event);
  }
}
